export default import.meta.ROLLDOWN_FILE_URL_N8gdGaVyOLPWXNFayxWuYg